import { render, staticRenderFns } from "./SelectSingleImageNew.vue?vue&type=template&id=783266d9&scoped=true&"
import script from "./SelectSingleImageNew.vue?vue&type=script&lang=js&"
export * from "./SelectSingleImageNew.vue?vue&type=script&lang=js&"
import style0 from "./SelectSingleImageNew.vue?vue&type=style&index=0&id=783266d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783266d9",
  null
  
)

export default component.exports